import { readContract } from '@wagmi/core'

import ChadAbi from '../config/ChadPumpAbi.json'
import ChadAbiV2 from '../config/ChadPumpAbiV2.json'

const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

type FetchDevArgs = {
  wagmiConfig: any
  contractAddress: string
  chainId: number
  versionType?: string
  signal?: AbortSignal
}

const METHOD_BY_VERSION = {
  v2: ['owner']
} as const

const DEFAULT_METHODS = ['creator', 'owner']

const normalizeAbi = (abiSource: any): any[] => {
  if (Array.isArray(abiSource)) return abiSource
  if (abiSource && Array.isArray(abiSource.abi)) return abiSource.abi
  return []
}

const abiHasFunction = (abi: any[], functionName: string) =>
  abi.some(
    item =>
      item &&
      typeof item === 'object' &&
      item.type === 'function' &&
      item.name === functionName
  )

export const fetchDevAddress = async ({
  wagmiConfig,
  contractAddress,
  chainId,
  versionType,
  signal
}: FetchDevArgs) => {
  const version = (versionType || '').toLowerCase()
  const abiSource = version === 'v2' ? ChadAbiV2 : ChadAbi
  const abi = normalizeAbi(abiSource)
  if (!abi.length) return undefined

  const configured = METHOD_BY_VERSION[version as 'v2'] || DEFAULT_METHODS
  const methods = (configured.length ? configured : DEFAULT_METHODS).filter(
    method => abiHasFunction(abi, method)
  )

  if (methods.length === 0) return undefined

  for (const method of methods) {
    try {
      const result = await readContract(wagmiConfig, {
        address: contractAddress,
        abi,
        functionName: method,
        chainId,
        signal
      })
      const addr = String(result || '').toLowerCase()
      if (addr && addr !== ZERO_ADDRESS) {
        return String(result)
      }
    } catch (err) {
      // ignore and try next method
    }
  }
  return undefined
}
